import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBarChartSignTooltipProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import BarChartSignKey from "../signKey";
import Text from "../../../text";

const BarChartSignTooltip: FC<IBarChartSignTooltipProps> = ({
    customTheme,
    content
}) => {
    const {
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle,
        value: valueDynamicStyle,
        row: rowDynamicStyle
    } = useStyles({
        iconSizes,
        spaces
    });

    return <View
        style={containerDynamicStyle}
    >
        <Text
            customTheme={customTheme}
            variant="bodySmallSize"
            color="mid"
        >
            {content.title}
        </Text>
        {
            content.rows.map((row) => <View
                style={[
                    stylesheet.row,
                    rowDynamicStyle
                ]}
                key={row.key}
            >
                <BarChartSignKey
                    color={row.key.startsWith("negative") ? colors.chart.diverging.negative : colors.chart.diverging.positive}
                    customTheme={customTheme}
                />
                <Text
                    customTheme={customTheme}
                    style={stylesheet.name}
                    variant="bodySmallSize"
                    numberOfLines={1}
                    color="mid"
                >
                    {row.title}
                </Text>
                <Text
                    customTheme={customTheme}
                    variant="titleSmallSize"
                    style={[
                        stylesheet.value,
                        valueDynamicStyle
                    ]}
                    color="high"
                >
                    {row.value}
                </Text>
            </View>)
        }
    </View>;
};
export default BarChartSignTooltip;
